import { DocumentIcon, FileIcon } from 'app/assets/icons';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { CustomToolTip } from '../CustomToolTip';

type Props = {
  title: string;
  value: string;
  type: 'active' | 'inactive' | 'closed' | 'upcomingRenewals' | 'sublimit';
};

export const SummaryTiles = ({ title, value, type }: Props) => {
  const theme = useTheme();
  return (
    <Wrapper className={type}>
      <div className="title-value-wrapper">
        <div className="tiles-title">{title}</div>
        <CustomToolTip>
          <div
            className="tiles-value"
            title={`${value} AED`}
          >{`${value} AED`}</div>
        </CustomToolTip>
      </div>
      {type === 'upcomingRenewals' || type === 'sublimit' ? (
        <DocumentIcon
          color={
            type === 'sublimit'
              ? theme.sublimitIconClr
              : theme.upcomingRenewalsIconClr
          }
        />
      ) : (
        <FileIcon
          color={
            type === 'active'
              ? theme.activeIconClr
              : type === 'inactive'
              ? theme.expiredIconClr
              : type === 'closed'
              ? theme.closedIconClr
              : undefined
          }
        />
      )}
    </Wrapper>
  );
};
const Wrapper = styled.div`
  font-family: 'Open Sans';
  font-weight: 700;
  background: ${p => p.theme.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 8px 0px 16px;
  border-radius: 15px;
  height: 80px;
  box-shadow: 0px 3.5px 5.5px 0px ${p => p.theme.summaryCardBoxShadow};
  .tiles-title {
    color: ${p => p.theme.tilesTitleClr};
    font-size: 12px;
  }
  .tiles-value {
    color: ${p => p.theme.tilesValueClr};
    font-size: 18px;
  }
  @media (min-width: 300px) and (max-width: 389px) {
    width: 100%;
    height: 85px;
    svg {
      width: 30px;
      min-width: 30px;
      height: 30px;
    }
    .tiles-title {
      font-size: 11px;
    }
    .tiles-value {
      font-size: 13px;
    }
  }
  @media (min-width: 390px) and (max-width: 480px) {
    width: 100%;
    height: 103px;
    svg {
      width: 40px;
      min-width: 40px;
      height: 40px;
    }
    .tiles-title {
      font-size: 12px;
    }
    .tiles-value {
      font-size: 15px;
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    width: 100%;
    height: 103px;
    svg {
      width: 43px;
      min-width: 43px;
      height: 43px;
    }
    .tiles-title {
      font-size: 12px;
    }
    .tiles-value {
      font-size: 15px;
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    width: 100%;
    height: 103px;
    svg {
      width: 40px;
      min-width: 40px;
      height: 40px;
    }
    .tiles-title {
      font-size: 11px;
    }
    .tiles-value {
      font-size: 16px;
    }
  }
  @media (min-width: 992px) and (max-width: 1023px) {
    width: 100%;
    height: 103px;
    svg {
      width: 40px;
      min-width: 40px;
      height: 40px;
    }
    .tiles-title {
      font-size: 11px;
    }
    .tiles-value {
      font-size: 16px;
    }
  }
  @media (min-width: 1024px) and (max-width: 1279px) {
    width: 100%;
    height: 103px;
    .tiles-title {
      font-size: 12px;
    }
    .tiles-value {
      font-size: 18px;
    }
  }
`;
